export const FAVORITES_MODAL_DEFAULT_OPTIONS = {
  size: 'md',
  styleOverride: {
    top: '50%',
    transform: 'translateY(-50%)',
  },
};
